"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1020],{

/***/ 4997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ CloseButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54799);
/* harmony import */ var _icon_24__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97946);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86896);





var DialogCloseIcon = "/icons/dialog/close.svg";
var CloseButton = function(param) {
    var _icon = param.icon, icon = _icon === void 0 ? DialogCloseIcon : _icon, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, sx = param.sx, handleClick = param.handleClick;
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        id: "close-icon",
        "aria-label": intl.formatMessage({
            id: "images.title.close"
        }),
        disabled: disabled,
        onClick: handleClick,
        sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            position: "absolute",
            top: 12,
            left: 12,
            opacity: disabled ? 0.4 : 1
        }, sx),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_icon_24__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            icon: icon,
            title: "alt.close"
        })
    });
};


/***/ }),

/***/ 61020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "SideMenu": function() { return /* binding */ SideMenu; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(98396);
// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js + 1 modules
var Drawer = __webpack_require__(58826);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(16216);
// EXTERNAL MODULE: ./node_modules/@mui/material/Avatar/Avatar.js + 2 modules
var Avatar = __webpack_require__(69661);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 2 modules
var Button = __webpack_require__(83321);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(36822);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItem/ListItem.js + 3 modules
var ListItem = __webpack_require__(97212);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemButton/ListItemButton.js
var ListItemButton = __webpack_require__(98619);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemIcon/ListItemIcon.js
var ListItemIcon = __webpack_require__(48885);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(59334);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js + 1 modules
var List = __webpack_require__(78462);
// EXTERNAL MODULE: ./node_modules/@mui/material/Collapse/Collapse.js + 1 modules
var Collapse = __webpack_require__(57922);
// EXTERNAL MODULE: ./node_modules/@mui/material/RadioGroup/RadioGroup.js
var RadioGroup = __webpack_require__(68061);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormControlLabel/FormControlLabel.js + 1 modules
var FormControlLabel = __webpack_require__(50480);
// EXTERNAL MODULE: ./node_modules/@mui/material/Radio/Radio.js + 5 modules
var Radio = __webpack_require__(36872);
// EXTERNAL MODULE: ./src/theme/typography.ts
var typography = __webpack_require__(43795);
;// CONCATENATED MODULE: ./src/components/side-menu/side-menu-dropdown.tsx



var SideMenuDropdown = function(param) {
    var isOpen = param.isOpen, dropDownTitle = param.dropDownTitle, selectedValue = param.selectedValue, data = param.data, onChange = param.onChange, onTransitionEnter = param.onTransitionEnter, onTransitionExited = param.onTransitionExited;
    var theme = (0,useTheme/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
        in: isOpen,
        timeout: "auto",
        onEnter: onTransitionEnter,
        onExited: onTransitionExited,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RadioGroup/* default */.Z, {
            "aria-labelledby": dropDownTitle,
            name: "".concat(dropDownTitle, "-group"),
            value: selectedValue,
            onChange: onChange,
            sx: {
                paddingX: "14px",
                paddingTop: "13px",
                paddingBottom: "8px"
            },
            children: data.map(function(param) {
                var id = param.id, value = param.value;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                    value: id,
                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                        className: "custom-secondary"
                    }),
                    label: value,
                    sx: {
                        color: theme.palette.common.white,
                        margin: "0px",
                        paddingY: "18.5px",
                        borderBottom: "1px solid ".concat(theme.palette.common.white),
                        "& .MuiRadio-root": {
                            padding: "0px",
                            marginRight: "16px"
                        },
                        "& .MuiFormControlLabel-label": {
                            fontSize: (0,typography/* pxToRem */.Q)(18),
                            letterSpacing: (0,typography/* pxToRem */.Q)(0.1)
                        },
                        "&:first-of-type": {
                            paddingTop: "0px"
                        },
                        "&:last-of-type": {
                            paddingBottom: "0px",
                            border: "none"
                        }
                    }
                }, id);
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/logic/state/index.ts + 18 modules
var state = __webpack_require__(42125);
// EXTERNAL MODULE: ./src/logic/services/index.ts + 21 modules
var services = __webpack_require__(10029);
// EXTERNAL MODULE: ./src/logic/hooks/index.ts + 27 modules
var hooks = __webpack_require__(7663);
// EXTERNAL MODULE: ./src/constants/prefetch.ts
var prefetch = __webpack_require__(86650);
// EXTERNAL MODULE: ./src/components/shared/customized-circular-progress.tsx
var customized_circular_progress = __webpack_require__(75491);
// EXTERNAL MODULE: ./src/components/shared/icon-24.tsx
var icon_24 = __webpack_require__(97946);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/features/wallet/components/wallet-access/my-balance-badge.tsx
var my_balance_badge = __webpack_require__(17067);
// EXTERNAL MODULE: ./src/constants/routes.ts
var routes = __webpack_require__(46648);
;// CONCATENATED MODULE: ./src/constants/side-menu.ts
var AboutUsIcon = "/icons/side-menu/about-us.svg";
var ContactUsIcon = "/icons/side-menu/contact-us.svg";
var ExperiencesIcon = "/icons/side-menu/experiences.svg";
var FoodMenuIcon = "/icons/side-menu/food-menu.svg";
var LocationOutlinedIcon = "/icons/side-menu/location-outlined.svg";
var NotificationIcon = "/icons/navbar/notification-icon.svg";
var NotificationRedDottedIcon = "/icons/navbar/notification-red-dotted-icon.svg";
var OffersIcon = "/icons/side-menu/offers.svg";
var PrivateBookingIcon = "/icons/side-menu/private-booking.svg";
var SearchIcon = "/icons/shared/search.svg";
var VouchersIcon = "/icons/side-menu/vouchers.svg";
var getPages = function(isAllNotificationsAreRead, openNotificationsPopover) {
    return [
        {
            title: "notificationsCenter",
            img: isAllNotificationsAreRead() ? NotificationIcon : NotificationRedDottedIcon,
            path: "fake-notification-link",
            isResponsive: true,
            isAuth: true,
            isLink: false,
            event: function() {
                return openNotificationsPopover();
            }
        },
        {
            title: "movieFinder",
            img: SearchIcon,
            path: "movie-finder",
            isResponsive: true,
            isAuth: false,
            isLink: true
        },
        {
            title: "cinemas",
            img: LocationOutlinedIcon,
            path: "cinemas",
            isResponsive: true,
            isAuth: false,
            isLink: true
        },
        {
            title: "experiences",
            img: ExperiencesIcon,
            path: "experiences",
            isResponsive: true,
            isAuth: false,
            isLink: true
        },
        {
            title: "offers",
            img: OffersIcon,
            path: "offers",
            isResponsive: true,
            isAuth: false,
            isLink: true
        },
        {
            title: "privateBooking",
            img: PrivateBookingIcon,
            path: "private-booking",
            isResponsive: false,
            isAuth: false,
            isLink: true
        },
        {
            title: "foodMenu",
            img: FoodMenuIcon,
            path: "food-menu",
            isResponsive: false,
            isAuth: false,
            isLink: true
        },
        {
            title: "vouchers",
            img: VouchersIcon,
            path: "voucher-redemption",
            isResponsive: false,
            isAuth: false,
            isLink: true
        },
        {
            title: "contactUs",
            img: ContactUsIcon,
            path: "contact-us",
            isResponsive: false,
            isAuth: false,
            isLink: true
        },
        {
            title: "aboutUs",
            img: AboutUsIcon,
            path: "about-us",
            isResponsive: false,
            isAuth: false,
            isLink: true
        }, 
    ];
};

// EXTERNAL MODULE: ./src/constants/wallet.ts
var wallet = __webpack_require__(45163);
// EXTERNAL MODULE: ./src/lang/locales.ts
var locales = __webpack_require__(59099);
// EXTERNAL MODULE: ./node_modules/zustand/esm/shallow.js
var shallow = __webpack_require__(60374);
// EXTERNAL MODULE: ./src/logic/hooks/use-notifications.ts
var use_notifications = __webpack_require__(32279);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/shared/close-button.tsx
var close_button = __webpack_require__(4997);
// EXTERNAL MODULE: ./src/components/shared/image-box-future.tsx
var image_box_future = __webpack_require__(58718);
;// CONCATENATED MODULE: ./src/components/side-menu/side-menu.tsx



























var ArrowDownIcon = "/icons/shared/arrow-down.svg";
var ArrowUpIcon = "/icons/side-menu/arrow-up.svg";
var AvatarImg = "/icons/side-menu/avatar.svg";
var SideMenuCloseIcon = "/icons/side-menu/close.svg";
var LocationFilledIcon = "/icons/side-menu/location-filled.svg";
var LocationWhiteIcon = "/icons/side-menu/location-white.svg";
var LogoutSideMenuIcon = "/icons/side-menu/logout-side-menu-icon.svg";
var GlobeGreyIcon = "/icons/side-menu/globe-grey.svg";
var GlobeWhiteIcon = "/icons/side-menu/globe-white.svg";
// TODO: change view profile button to link or button in case of logged in user or logged out user
var SideMenu = function() {
    var theme = (0,useTheme/* default */.Z)();
    var intl = (0,useIntl/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var isMediumScreen = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("extraLargeDesktop"));
    var ref = (0,react.useState)(false), isCitiesDropDownOpen = ref[0], setIsCitiesDropDownOpen = ref[1];
    var ref1 = (0,react.useState)(false), isCommunicationLanguagesDropDownOpen = ref1[0], setIsCommunicationLanguagesDropDownOpen = ref1[1];
    var ref2 = (0,react.useState)(false), isCitiesTransitionStarted = ref2[0], setIsCitiesTransitionStarted = ref2[1];
    var ref3 = (0,react.useState)(false), isCommunicationLanguagesTransitionStarted = ref3[0], setIsCommunicationLanguagesTransitionStarted = ref3[1];
    var setSnack = (0,state/* useSnack */.eW)(function(s) {
        return s.setSnack;
    }, shallow/* default */.Z);
    var setDialog = (0,state/* useDialog */.Rh)(function(s) {
        return s.setDialog;
    }, shallow/* default */.Z);
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,state/* useSideMenu */.W0)(function(s) {
        return [
            s.isSideMenuOpen,
            s.setSideMenu
        ];
    }, shallow/* default */.Z), 2), isSideMenuOpen = ref4[0], setSideMenu = ref4[1];
    var cities = (0,state/* useCities */.M1)(function(s) {
        return s.cities;
    }, shallow/* default */.Z);
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,state/* useGuest */.Js)(function(s) {
        return [
            s.guest,
            s.setGuest
        ];
    }, shallow/* default */.Z), 2), guest = ref5[0], setGuest = ref5[1];
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,state/* useAuth */.aC)(function(s) {
        return [
            s.user,
            s.setUser
        ];
    }, shallow/* default */.Z), 2), user = ref6[0], setUser = ref6[1];
    var ref7 = (0,services/* useGetCommunicationLanguages */.Ko)(), communicationLanguages = ref7.data;
    var updateCommunicationLanguage = (0,services/* useUpdateCommunicationLanguage */.uO)();
    var isAllNotificationsAreRead = (0,use_notifications/* useNotifications */.z)().isAllNotificationsAreRead;
    var citiesData = cities.citiesList.map(function(city) {
        return {
            id: city.id,
            value: city.name
        };
    });
    var handleCloseSideMenu = (0,react.useCallback)(function() {
        setSideMenu(false);
        setIsCitiesDropDownOpen(false);
        setIsCommunicationLanguagesDropDownOpen(false);
    }, [
        setSideMenu
    ]);
    var updateUserSelectedCity = (0,hooks/* useUpdateUserSelectedCity */.GC)(handleCloseSideMenu);
    var ref8;
    var communicationLanguagesData = (ref8 = communicationLanguages === null || communicationLanguages === void 0 ? void 0 : communicationLanguages.communicationLanguage.map(function(communicationLanguage) {
        return {
            id: communicationLanguage.id,
            value: communicationLanguage.language
        };
    })) !== null && ref8 !== void 0 ? ref8 : [];
    var getSelectedCityName = (0,react.useCallback)(function(selectedCityId) {
        var ref;
        var ref1;
        return (ref1 = (ref = cities.citiesList.find(function(city) {
            return city.id === selectedCityId;
        })) === null || ref === void 0 ? void 0 : ref.name) !== null && ref1 !== void 0 ? ref1 : intl.formatMessage({
            id: "global.city"
        });
    }, [
        cities.citiesList,
        intl
    ]);
    var handleLogoutClick = (0,react.useCallback)(function() {
        handleCloseSideMenu();
        setDialog({
            wrapper: true,
            isLogoutConfirmDialog: true
        });
    }, [
        handleCloseSideMenu,
        setDialog
    ]);
    var handleCommunicationLanguageChange = (0,react.useCallback)(function(e) {
        updateCommunicationLanguage.safeMutateAsync({
            data: {
                communicationLanguageId: Number(e.target.value)
            }
        }, {
            onSuccess: function(data) {
                var _user = data.user, _ = _user.language, restUserData = (0,_object_without_properties/* default */.Z)(_user, [
                    "language"
                ]);
                setUser(function(prevState) {
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState, restUserData), {
                        communicationLanguageId: data.user.communicationLanguageId
                    });
                });
                setSnack({
                    isOpen: true,
                    message: "communication_languages.update.success",
                    type: "success"
                });
                handleCloseSideMenu();
            }
        });
    }, [
        handleCloseSideMenu,
        setSnack,
        setUser,
        updateCommunicationLanguage
    ]);
    var switchLang = (0,hooks/* useSwitchLang */.Ns)().switchLang;
    var handleLanguageChange = (0,react.useCallback)(function(language) {
        if (user) {
            setUser(function(prevState) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                    language: language
                });
            });
        } else {
            setGuest(function(prevState) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                    language: language
                });
            });
        }
        switchLang(language);
        handleCloseSideMenu();
        setSnack({
            isOpen: true,
            message: "languages.update.success",
            type: "success"
        });
    }, [
        user,
        switchLang,
        handleCloseSideMenu,
        setSnack,
        setUser,
        setGuest
    ]);
    var selectedLanguage = router.locale;
    var openNotificationsPopover = function() {
        setDialog({
            wrapper: true,
            isNotificationPopover: true
        });
        setSideMenu(false);
    };
    var checkIfLinkIsActive = function(path) {
        var currentRoute = router.pathname.split("/");
        if (!currentRoute || !(currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.length)) return;
        if (currentRoute[1] === path) {
            return true;
        }
        return false;
    };
    var ref9;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer/* default */.ZP, {
        variant: "temporary",
        open: isSideMenuOpen,
        onClose: handleCloseSideMenu,
        ModalProps: {
            keepMounted: true
        },
        sx: {
            "& .MuiDrawer-paper": {
                width: {
                    mobile: "300px",
                    mediumDesktop: "367px"
                },
                paddingX: "10px",
                paddingY: "24px",
                borderRadius: "0 12px 12px 0",
                overflowY: {
                    tablet: "auto",
                    mobile: "scroll"
                }
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(close_button/* CloseButton */.P, {
                icon: SideMenuCloseIcon,
                sx: {
                    position: "static",
                    alignSelf: "flex-end"
                },
                handleClick: handleCloseSideMenu
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                spacing: 3,
                sx: {
                    paddingX: "14px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                        sx: {
                            width: {
                                mobile: "70px",
                                tablet: "84px"
                            },
                            height: {
                                mobile: "70px",
                                tablet: "84px"
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                            img: (ref9 = user === null || user === void 0 ? void 0 : user.photoUrl) !== null && ref9 !== void 0 ? ref9 : AvatarImg,
                            title: intl.formatMessage({
                                id: (user === null || user === void 0 ? void 0 : user.photoUrl) ? "alt.user_img" : "alt.avatar"
                            }),
                            objectFit: "cover",
                            sx: {
                                width: "100%",
                                height: "100%"
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        spacing: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                component: "span",
                                sx: {
                                    color: theme.palette.primary.main,
                                    fontSize: (0,typography/* pxToRem */.Q)(20),
                                    fontFamily: "co-head-line-corp-bold",
                                    overflowWrap: "anywhere"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: user && user.firstName ? "sideMenu.loggedInUserGreet" : "sideMenu.guestGreet",
                                    values: {
                                        name: user === null || user === void 0 ? void 0 : user.firstName
                                    }
                                })
                            }),
                            user && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: {
                                    pathname: routes/* PATHS.USER_AREA */.yy.USER_AREA
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    variant: "darkGrey",
                                    href: "/user-area",
                                    fullWidth: false,
                                    sx: {
                                        fontSize: (0,typography/* pxToRem */.Q)(14),
                                        fontFamily: "co-head-line-corp-bold",
                                        lineHeight: 24 / 14,
                                        paddingX: "35px",
                                        paddingY: "8px",
                                        borderRadius: "12px"
                                    },
                                    onClick: function() {
                                        handleCloseSideMenu();
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "sideMenu.viewProfile"
                                    })
                                })
                            }),
                            !user && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                id: "sidebar-login-button",
                                variant: "darkGrey",
                                fullWidth: false,
                                sx: {
                                    fontSize: (0,typography/* pxToRem */.Q)(14),
                                    fontFamily: "co-head-line-corp-bold",
                                    lineHeight: 24 / 14,
                                    paddingX: "35px",
                                    paddingY: "8px",
                                    borderRadius: "12px"
                                },
                                onClick: function() {
                                    handleCloseSideMenu();
                                    setDialog(function(prevState) {
                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                                            wrapper: true,
                                            isPhoneNumberForm: true
                                        });
                                    });
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "sideMenu.login"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                direction: "row",
                alignItems: "center",
                sx: {
                    marginTop: "52px",
                    marginBottom: "10px",
                    paddingX: "14px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            minWidth: 40
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_24/* default */.Z, {
                            icon: GlobeGreyIcon,
                            title: "alt.globe_icon"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        alignItems: "center",
                        spacing: 3,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                sx: {
                                    minWidth: "auto",
                                    fontSize: (0,typography/* pxToRem */.Q)(18),
                                    lineHeight: 27 / 18,
                                    letterSpacing: (0,typography/* pxToRem */.Q)(0.1),
                                    color: theme.palette.grey[60],
                                    opacity: selectedLanguage === locales/* locales.EN */.k1.EN ? 1 : 0.6
                                },
                                onClick: function() {
                                    return handleLanguageChange(locales/* locales.EN */.k1.EN);
                                },
                                children: "English"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                sx: {
                                    minWidth: "auto",
                                    color: theme.palette.grey[60],
                                    opacity: selectedLanguage === locales/* locales.AR */.k1.AR ? 1 : 0.6
                                },
                                onClick: function() {
                                    return handleLanguageChange(locales/* locales.AR */.k1.AR);
                                },
                                children: "عربي"
                            })
                        ]
                    })
                ]
            }),
            wallet/* isWalletFeatureEnabled */.jG && /*#__PURE__*/ (0,jsx_runtime.jsx)(my_balance_badge/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.ZP, {
                disableGutters: true,
                component: "div",
                sx: {
                    borderRadius: "12px",
                    marginBottom: "2.5px",
                    backgroundColor: isCitiesTransitionStarted ? theme.palette.primary.main : "transparent",
                    display: {
                        mobile: "block",
                        mediumDesktop: "none"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemButton/* default */.Z, {
                        component: "button",
                        disableGutters: true,
                        sx: {
                            borderRadius: "12px",
                            paddingX: "14px",
                            width: "100%",
                            ":hover": {
                                backgroundColor: "transparent"
                            }
                        },
                        onClick: function() {
                            return setIsCitiesDropDownOpen(function(prevState) {
                                return !prevState;
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                sx: {
                                    minWidth: 40
                                },
                                children: updateUserSelectedCity.isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(customized_circular_progress/* default */.Z, {
                                    size: 15,
                                    thickness: 4
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_24/* default */.Z, {
                                    icon: isCitiesTransitionStarted ? LocationWhiteIcon : LocationFilledIcon,
                                    title: "images.title.location"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                sx: {
                                    "& span": {
                                        fontSize: (0,typography/* pxToRem */.Q)(18),
                                        letterSpacing: (0,typography/* pxToRem */.Q)(0.1),
                                        color: isCitiesTransitionStarted ? theme.palette.common.white : theme.palette.grey[60]
                                    }
                                },
                                children: (user === null || user === void 0 ? void 0 : user.preferredCityId) ? getSelectedCityName(user.preferredCityId) : (guest === null || guest === void 0 ? void 0 : guest.preferredCityId) ? getSelectedCityName(guest.preferredCityId) : /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "global.city"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_24/* default */.Z, {
                                icon: isCitiesTransitionStarted ? ArrowUpIcon : ArrowDownIcon,
                                title: isCitiesTransitionStarted ? "alt.arrow_up_icon" : "alt.arrow_down_icon"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SideMenuDropdown, {
                        isOpen: isCitiesDropDownOpen,
                        dropDownTitle: "city",
                        selectedValue: user ? user.preferredCityId : guest ? guest.preferredCityId : null,
                        data: citiesData,
                        onChange: updateUserSelectedCity.update,
                        onTransitionEnter: function() {
                            return setIsCitiesTransitionStarted(true);
                        },
                        onTransitionExited: function() {
                            return setIsCitiesTransitionStarted(false);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                component: "nav",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
                    sx: {
                        padding: "0px"
                    },
                    children: getPages(isAllNotificationsAreRead, openNotificationsPopover).map(function(param) {
                        var title = param.title, img = param.img, path = param.path, isResponsive = param.isResponsive, isAuth = param.isAuth, isLink = param.isLink, event = param.event;
                        return isAuth && user || !isAuth ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                            disableGutters: true,
                            sx: {
                                paddingY: "10.5px",
                                display: {
                                    mobile: "flex",
                                    mediumDesktop: isResponsive ? "none" : "flex"
                                }
                            },
                            children: isLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: {
                                    pathname: "/".concat(path)
                                },
                                passHref: true,
                                prefetch: prefetch/* ALLOW_SIDE_MENU_ITEMS_PREFETCH */.vN,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemButton/* default */.Z, {
                                    component: "a",
                                    disableGutters: true,
                                    sx: {
                                        borderRadius: "12px",
                                        paddingX: "14px",
                                        backgroundColor: checkIfLinkIsActive(path) && theme.palette.lightGrey.main
                                    },
                                    onClick: function() {
                                        return setSideMenu(false);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                            sx: {
                                                minWidth: 40
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_24/* default */.Z, {
                                                icon: img,
                                                title: "nav.link.".concat(title)
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                            sx: {
                                                "& span": {
                                                    fontSize: (0,typography/* pxToRem */.Q)(18),
                                                    letterSpacing: (0,typography/* pxToRem */.Q)(0.1),
                                                    color: checkIfLinkIsActive(path) ? theme.palette.primary.main : theme.palette.grey[60]
                                                }
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                id: "nav.link.".concat(title)
                                            })
                                        })
                                    ]
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                fullWidth: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemButton/* default */.Z, {
                                    component: "a",
                                    disableGutters: true,
                                    sx: {
                                        "& span": {
                                            fontSize: (0,typography/* pxToRem */.Q)(18),
                                            letterSpacing: (0,typography/* pxToRem */.Q)(0.1),
                                            color: checkIfLinkIsActive(path) ? theme.palette.primary.main : theme.palette.grey[60]
                                        },
                                        borderRadius: "12px",
                                        paddingX: "14px"
                                    },
                                    onClick: function() {
                                        return event();
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                            sx: {
                                                minWidth: 40
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_24/* default */.Z, {
                                                icon: img,
                                                title: "nav.link.".concat(title)
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                            sx: {
                                                "& span": {
                                                    fontSize: (0,typography/* pxToRem */.Q)(18),
                                                    letterSpacing: (0,typography/* pxToRem */.Q)(0.1)
                                                }
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                                id: "nav.link.".concat(title)
                                            })
                                        })
                                    ]
                                })
                            })
                        }, title) : null;
                    })
                })
            }),
            user && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItem/* default */.ZP, {
                disableGutters: true,
                component: "div",
                sx: {
                    display: "block",
                    borderRadius: "12px",
                    marginTop: "2.5px",
                    marginBottom: user ? "15.5px" : "0px",
                    backgroundColor: isCommunicationLanguagesTransitionStarted ? theme.palette.primary.main : "transparent"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemButton/* default */.Z, {
                        component: "button",
                        disableGutters: true,
                        sx: {
                            borderRadius: "12px",
                            paddingX: "14px",
                            width: "100%",
                            ":hover": {
                                backgroundColor: "transparent"
                            }
                        },
                        onClick: function() {
                            return setIsCommunicationLanguagesDropDownOpen(function(prevState) {
                                return !prevState;
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                sx: {
                                    minWidth: 40
                                },
                                children: updateCommunicationLanguage.isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(customized_circular_progress/* default */.Z, {
                                    size: isMediumScreen ? 15 : 24,
                                    thickness: 4
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_24/* default */.Z, {
                                    icon: isCommunicationLanguagesTransitionStarted ? GlobeWhiteIcon : GlobeGreyIcon,
                                    title: "alt.globe_icon"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                sx: {
                                    "& span": {
                                        fontSize: (0,typography/* pxToRem */.Q)(18),
                                        letterSpacing: (0,typography/* pxToRem */.Q)(0.1),
                                        color: isCommunicationLanguagesTransitionStarted ? theme.palette.common.white : theme.palette.grey[60]
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "sideMenu.communicationLanguage"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_24/* default */.Z, {
                                icon: isCommunicationLanguagesTransitionStarted ? ArrowUpIcon : ArrowDownIcon,
                                title: isCommunicationLanguagesTransitionStarted ? "alt.arrow_up_icon" : "alt.arrow_down_icon"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SideMenuDropdown, {
                        isOpen: isCommunicationLanguagesDropDownOpen,
                        dropDownTitle: "communicationLanguage",
                        selectedValue: user.communicationLanguageId,
                        data: communicationLanguagesData,
                        onChange: handleCommunicationLanguageChange,
                        onTransitionEnter: function() {
                            return setIsCommunicationLanguagesTransitionStarted(true);
                        },
                        onTransitionExited: function() {
                            return setIsCommunicationLanguagesTransitionStarted(false);
                        }
                    })
                ]
            }),
            user && /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                component: "div",
                disableGutters: true,
                sx: {
                    marginTop: "auto"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemButton/* default */.Z, {
                    component: "a",
                    disableGutters: true,
                    sx: {
                        borderRadius: "12px",
                        paddingX: "14px"
                    },
                    onClick: handleLogoutClick,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                            sx: {
                                minWidth: 40
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(image_box_future/* default */.Z, {
                                img: LogoutSideMenuIcon,
                                title: intl.formatMessage({
                                    id: "alt.logout_icon"
                                }),
                                objectFit: "contain",
                                sx: {
                                    width: "24px",
                                    height: "24px"
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                            sx: {
                                "& span": {
                                    fontSize: (0,typography/* pxToRem */.Q)(18),
                                    letterSpacing: (0,typography/* pxToRem */.Q)(0.1),
                                    color: theme.palette.grey[60]
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                id: "nav.link.logout"
                            })
                        })
                    ]
                })
            })
        ]
    });
};


/***/ }),

/***/ 17067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ MyBalanceBadge; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(97212);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(98619);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(16216);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(36822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(83321);
/* harmony import */ var _logic_state__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42125);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(44012);
/* harmony import */ var _mui_icons_material_KeyboardArrowLeft__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(76172);
/* harmony import */ var _mui_icons_material_KeyboardArrowRight__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(48317);
/* harmony import */ var _wallet_side_menu_auth_hint__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53830);
/* harmony import */ var _lang_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61671);
/* harmony import */ var _theme_typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43795);
/* harmony import */ var zustand_shallow__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(60374);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _features_wallet_hooks_use_user_balance__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33433);
/* harmony import */ var _logic_hooks_use_user_types__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44458);
/* harmony import */ var _constants_routes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(46648);















var ArrowIconSx = {
    transition: "0.3s ease-out",
    "&:hover": {
        transition: "0.3s ease-out",
        WebkitTransform: "translateX(4px)",
        MozTransform: "translateX(4px)",
        msTransform: "translateX(4px)",
        OTransform: "translateX(4px)",
        transform: "translateX(4px)",
        WebkitTransition: "transform 0.3s ease-out",
        MozTransition: "transform 0.3s ease-out",
        msTransition: "transform 0.3s ease-out",
        OTransition: "transform 0.3s ease-out"
    }
};
var MyBalanceBadge = function(param) {
    var customArrowButtonSx = param.customArrowButtonSx;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)();
    var user = (0,_logic_state__WEBPACK_IMPORTED_MODULE_1__/* .useAuth */ .aC)(function(s) {
        return s.user;
    }, zustand_shallow__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z);
    var setSideMenu = (0,_logic_state__WEBPACK_IMPORTED_MODULE_1__/* .useSideMenu */ .W0)(function(s) {
        return s.setSideMenu;
    }, zustand_shallow__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z);
    var setDialog = (0,_logic_state__WEBPACK_IMPORTED_MODULE_1__/* .useDialog */ .Rh)(function(s) {
        return s.setDialog;
    }, zustand_shallow__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var userType = (0,_logic_hooks_use_user_types__WEBPACK_IMPORTED_MODULE_7__/* .useUserTypes */ .Z)().userType;
    var isRtl = (0,_lang_utils__WEBPACK_IMPORTED_MODULE_3__/* .checkIsRtl */ .TM)(router.locale);
    var userFormattedBalance = (0,_features_wallet_hooks_use_user_balance__WEBPACK_IMPORTED_MODULE_6__/* .useUserBalance */ .F)().userFormattedBalance;
    var handleBalanceBadgeClick = function() {
        setSideMenu(false);
        if (!user) {
            setDialog(function() {
                return {
                    wrapper: true,
                    isPhoneNumberForm: true
                };
            });
            return;
        }
        if (userType === _logic_hooks_use_user_types__WEBPACK_IMPORTED_MODULE_7__/* .UserType.Completed */ .F.Completed || userType === _logic_hooks_use_user_types__WEBPACK_IMPORTED_MODULE_7__/* .UserType.Verified */ .F.Verified || userType === _logic_hooks_use_user_types__WEBPACK_IMPORTED_MODULE_7__/* .UserType.NonVerified */ .F.NonVerified) {
            router.push(_constants_routes__WEBPACK_IMPORTED_MODULE_8__/* .PATHS.USER_AREA */ .yy.USER_AREA);
            return;
        }
        if (userType === _logic_hooks_use_user_types__WEBPACK_IMPORTED_MODULE_7__/* .UserType.NonCompleted */ .F.NonCompleted) {
            setDialog(function() {
                return {
                    wrapper: true,
                    isCompleteProfileForm: true,
                    completeProfileFormPayload: {
                        hideMaybeLaterButton: true
                    }
                };
            });
            return;
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
        component: "div",
        disableGutters: true,
        sx: {
            paddingY: "10.5px",
            display: {
                mobile: "flex",
                mediumDesktop: "flex"
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
            component: "a",
            disableGutters: true,
            sx: {
                borderRadius: "12px",
                paddingX: "16px",
                paddingY: "8px",
                backgroundColor: theme.palette.lightGrey.main
            },
            onClick: handleBalanceBadgeClick,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                direction: "row",
                sx: {
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexGrow: 1
                },
                children: [
                    user ? userType === _logic_hooks_use_user_types__WEBPACK_IMPORTED_MODULE_7__/* .UserType.Completed */ .F.Completed || userType === _logic_hooks_use_user_types__WEBPACK_IMPORTED_MODULE_7__/* .UserType.Verified */ .F.Verified || userType === _logic_hooks_use_user_types__WEBPACK_IMPORTED_MODULE_7__/* .UserType.NonVerified */ .F.NonVerified ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                sx: {
                                    fontSize: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(16),
                                    fontWeight: "400",
                                    color: theme.palette.grey[60],
                                    marginBottom: "4px"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                    id: "wallet.my.balance"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                                component: "span",
                                sx: {
                                    fontSize: (0,_theme_typography__WEBPACK_IMPORTED_MODULE_4__/* .pxToRem */ .Q)(20),
                                    fontWeight: "700",
                                    color: theme.palette.grey[60]
                                },
                                children: [
                                    userFormattedBalance,
                                    "\xa0",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        id: "currency.SAR"
                                    })
                                ]
                            })
                        ]
                    }) : userType === _logic_hooks_use_user_types__WEBPACK_IMPORTED_MODULE_7__/* .UserType.NonCompleted */ .F.NonCompleted ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wallet_side_menu_auth_hint__WEBPACK_IMPORTED_MODULE_2__/* .WalletSidMenuAuthHint */ .u, {
                        message: "wallet.user_not_completed_profile.side_menu",
                        img: "/icons/profile/wallet-cashback-profile-icon.svg"
                    }) : null : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_wallet_side_menu_auth_hint__WEBPACK_IMPORTED_MODULE_2__/* .WalletSidMenuAuthHint */ .u, {
                        message: "wallet.user_is_guest",
                        img: "/icons/profile/wallet-cashback-login-icon.svg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        sx: {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                            variant: "contained",
                            sx: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({
                                width: "32px",
                                height: "32px",
                                borderRadius: "100%",
                                minWidth: "unset",
                                minHeight: "unset"
                            }, customArrowButtonSx),
                            children: isRtl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_KeyboardArrowLeft__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                sx: ArrowIconSx
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_icons_material_KeyboardArrowRight__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                sx: ArrowIconSx
                            })
                        })
                    })
                ]
            })
        })
    }, "e-wallet-badge");
};
/* harmony default export */ __webpack_exports__["Z"] = (MyBalanceBadge);


/***/ }),

/***/ 53830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ WalletSidMenuAuthHint; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86896);
/* harmony import */ var react_intl__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44012);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16216);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15861);
/* harmony import */ var _components_shared_image_box_future__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58718);




var WalletSidMenuAuthHint = function(param) {
    var message = param.message, img = param.img, textColor = param.textColor;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var intl = (0,react_intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        direction: "row",
        sx: {
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_image_box_future__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                img: img,
                title: intl.formatMessage({
                    id: "alt.my_wallet"
                }),
                objectFit: "contain",
                sx: {
                    minWidth: "31px",
                    minHeight: "35px"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                component: "span",
                sx: {
                    fontSize: "16px",
                    color: textColor || theme.palette.grey[60],
                    marginX: "7px"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_intl__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    id: message
                })
            })
        ]
    });
};


/***/ }),

/***/ 33433:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ useUserBalance; }
/* harmony export */ });
/* harmony import */ var zustand_shallow__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60374);
/* harmony import */ var _logic_state__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(42125);


// This custom hook is used to get user wallet data
var useUserBalance = function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var user = (0,_logic_state__WEBPACK_IMPORTED_MODULE_0__/* .useAuth */ .aC)(function(s) {
        return s.user;
    }, zustand_shallow__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
    var ref6, ref7, ref8;
    return {
        userFormattedBalance: (ref6 = user === null || user === void 0 ? void 0 : (ref = user.totalDetailedBalance) === null || ref === void 0 ? void 0 : (ref1 = ref.toFixed) === null || ref1 === void 0 ? void 0 : ref1.call(ref, 2)) !== null && ref6 !== void 0 ? ref6 : 0..toFixed(2),
        userFormattedWalletBalance: (ref7 = user === null || user === void 0 ? void 0 : (ref2 = user.walletDetailedBalance) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.toFixed) === null || ref3 === void 0 ? void 0 : ref3.call(ref2, 2)) !== null && ref7 !== void 0 ? ref7 : 0..toFixed(2),
        userFormattedCashbackBalance: (ref8 = user === null || user === void 0 ? void 0 : (ref4 = user.cashbackDetailedBalance) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.toFixed) === null || ref5 === void 0 ? void 0 : ref5.call(ref4, 2)) !== null && ref8 !== void 0 ? ref8 : 0..toFixed(2),
        userNextExpiredWalletTransaction: user === null || user === void 0 ? void 0 : user.walletTransaction,
        userNextExpiredCashbackTransaction: user === null || user === void 0 ? void 0 : user.cashbackTransaction
    };
};


/***/ })

}]);